"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _onResize = require("./onResize");

var selectors = [];
var callbacks = [];

var equalwidth = function equalwidth(selector) {
  var maxWidth = 0;
  var nodeList = Array.from(document.querySelectorAll(selector));
  nodeList.each(function (node) {
    // const $this = $(this);
    node.style.width = 'auto'; // $this.css('width', 'auto');

    var d = parseFloat(getComputedStyle(node, null).width.replace('px', ''));
    node.setAttribute('data-width', d); // $this.attr('data-width', $(this).width());
    // d = $this.attr('data-width');

    maxWidth = Math.max(maxWidth, d);
  });
  nodeList.each(function (node) {
    node.style.width = "".concat(maxWidth, "px");
  });
};

var registerSelector = function registerSelector(selector, callback) {
  equalwidth(selector);
  selectors.push(selector);

  if (callback !== undefined) {
    callbacks.push(callback);
  } else {
    callbacks.push(function () {});
  }
};

var execute = function execute() {
  var callback;

  for (var i = 0, len = selectors.length; i < len; i += 1) {
    equalwidth(selectors[i]);
    callback = callbacks[i];
    callback();
  }
};

(0, _onResize.onResize)(execute);
var _default = registerSelector;
exports["default"] = _default;